import axios from "axios";

export async function getLocationName(latitude, longitude) {
  try {
    const response = await axios.get(
      "https://nominatim.openstreetmap.org/reverse",
      {
        params: {
          lat: latitude,
          lon: longitude,
          format: "jsonv2",
          addressdetails: 1,
        },
        headers: {
          "User-Agent": "HRMS-SaaS-Frontend/1.0",
        },
      }
    );

    const data = response.data;

    return {
      fullAddress: data.display_name,
      area:
        data.address?.suburb ||
        data.address?.neighbourhood ||
        data.address?.village ||
        data.address?.town ||
        data.address?.city ||
        "",
      city: data.address?.city || data.address?.town || "",
      state: data.address?.state || "",
      country: data.address?.country || "",
      pincode: data.address?.postcode || "",
    };
  } catch (error) {
    console.error("Reverse geocoding failed:", error.message);
    return null;
  }
}
